import React from "react";
import moment from "moment-timezone";
import get from "lodash/get";
import { Link } from "react-router";
import { ListItem } from "material-ui";
import * as util from "../../../util";
import withWidth from "material-ui/utils/withWidth";

import TenantIcon from "../icons/tenant-icon.jsx";

import PassSubscriptionActions from "../../../actions/PassSubscriptionActions";

class PassSubscriptionListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isUpdating: false
    };

    this._getIcon = this._getIcon.bind(this);

    this.enableAutorenew = this.enableAutorenew.bind(this);
    this.disableAutorenew = this.disableAutorenew.bind(this);
    this.edit = this.edit.bind(this);
    this.renew = this.renew.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object,
      tenant: React.PropTypes.object
    };
  }

  _getIcon() {
    let styles = this.getStyles(),
      name = this.context.tenant.pass_icons[
        get(this.props.item, "pass_bucket.code")
      ];

    return name ? <TenantIcon name={name} style={styles.icon} /> : null;
  }

  getStyles() {
    return {
      icon: {
        height: "50px",
        display: "block",
        verticalAlign: "middle",
        fontSize: 45,
        textAlign: "center",
        paddingTop: 20
      },
      a: {
        textDecoration: "underline",
        cursor: "pointer",
        color: "rgba(0, 0, 0, 0.54)"
      }
    };
  }

  componentWillReceiveProps(newProps) {
    //pass
  }

  enableAutorenew() {
    this.edit({
      should_autorenew: true
    });
  }

  disableAutorenew() {
    this.edit({
      should_autorenew: false
    });
  }

  renew() {
    this.context.router.push(
      `/subscriptions/renew?subscription=${this.props.item.id}`
    );
  }

  edit(data) {
    this._lastUpdatedAt = this.props.item.updated_at;
    this.setState({
      isUpdating: true
    });

    PassSubscriptionActions.editPassSubscription(this.props.item.id, data);
  }

  componentWillReceiveProps(newProps) {
    // Assume updated pass subscription
    if (
      this.state.isUpdating &&
      newProps.item.updated_at !== this._lastUpdatedAt
    ) {
      this.setState({
        isUpdating: false
      });
    }
  }

  render() {
    var passSubscription = this.props.item,
      styles = this.getStyles();

    return (
      <ListItem
        secondaryText={
          passSubscription.passes.length ? (
            <p>
              {passSubscription.passes.map(p => p.name).join(", ")} |{" "}
              <Link
                style={styles.a}
                to={`/${this.context.tenant.memberships_url_pathname}`}
              >
                view membership{passSubscription.passes.length > 1 ? "s" : ""}
              </Link>
              <br />
              {util.formatSubscriptionStatus(passSubscription)} |{" "}
              {this.state.isUpdating ? (
                <a style={styles.a}>loading...</a>
              ) : passSubscription.status === "active" ? (
                passSubscription.should_autorenew ? (
                  <a style={styles.a} onClick={this.disableAutorenew}>
                    disable autorenew
                  </a>
                ) : (
                  <a style={styles.a} onClick={this.enableAutorenew}>
                    enable autorenew
                  </a>
                )
              ) : null}{" "}
              |{" "}
              <a style={styles.a} onClick={this.renew}>
                renew now
              </a>
            </p>
          ) : (
            <p>
              All items in this subscription have been deleted. You will not be
              charged.
            </p>
          )
        }
        leftIcon={this._getIcon()}
        secondaryTextLines={2}
        disabled={true}
        primaryText={
          <div>
            {`${passSubscription.quantity}x ${passSubscription.pass_bucket.name}`}
          </div>
        }
      />
    );
  }
}

export default withWidth()(PassSubscriptionListItem);



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-subscription-list/pass-subscription-list-item.jsx